define('ShippingDeliveryLocation.View', [
    'Backbone',
    'jQuery',
    'underscore',
    'shippingdeliverylocation.tpl',
    'ShippingDeliveryLocation.Result',
    'Profile.Model',
    'ShippingDeliveryLocation.Collection',
    'Utils',
    'SC.Configuration',
    'js.cookie'
], function View(
    Backbone,
    jQuery,
    _,
    shippingDeliveryLocationTpl,
    ShippingDeliveryLocationResult,
    ProfileModel,
    StoreSelectorCollection,
    Utils,
    Configuration,
    Cookies
) {
    'use strict';

    return Backbone.View.extend({

        template: shippingDeliveryLocationTpl,

        title: Configuration.get('ShippingDeliveryLocation.modalTitle'),

        events: {
            'submit form': 'searchStores',
            'keydown .store-finder-content': 'keyPressDropdown'
        },
        childViews: {
            'Store.Selector.Results': function storeSelectorResultsView() {
                return new ShippingDeliveryLocationResult({
                    collection: this.collection,
                    profile: ProfileModel.getInstance()
                });
            }
        },
        initialize: function initialize(options) {
            this.application = options.application;
            this.collection = new StoreSelectorCollection();
            // this.collection.fetch();
            this.on('afterViewRender', function afterViewRenderedFn() {
                Cookies.set('is_displayed_shipping_delivery_modal', true);
            });
            this.title = Configuration.get('ShippingDeliveryLocation.modalTitle');
        },
        keyPressDropdown: function keyPressDropdown(e) {
            if (e.keyCode === 27) {
                this.application.getLayout().$('#store-finder-container').dropdown('toggle');
            }
        },
        searchStores: function switchStore(e) {
            var $input = this.$('[name="zipcode"]');
            var value = $input.val();
            e.preventDefault();

            if (!value || value.length !== 5) {
                this.$('.zip-error').text(Utils.translate('Invalid ZipCode'));
                return;
            }

            this.$('.zip-error').text('');
            this.collection.fetch({
                data: {
                    zipcode: $input.val()
                }
            });
        },
        getContext: function getContext() {
            return {
                message: Configuration.get('ShippingDeliveryLocation.modalText')
            };
        }
    });
});
